<template>
  <div class="BomPartsAlternativeAggregatedTableComponent DataTables">

    <div v-show="isData" :id="id"></div>
    <ContextMenuComponent :menu="menu" :id="id"></ContextMenuComponent>
    <LoaderComponent  v-show="!isData"></LoaderComponent>
      <!-- <span v-show="!isData">{{lang.NoContent}}</span> -->

  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import LoaderComponent from "@/components/shared/LoaderComponent";
import ContextMenuComponent from "@/components/shared/ContextMenuComponent";
var $ = require('jquery');
import dt from 'datatables.net-bs4';
import * as Tools from './../../Tools/Tools'

export default {
  name: 'BomPartsAlternativeAggregatedTableComponent',
  props:{
    lang: Object,
    tabIndex: Number
  },
  components: {
    LoaderComponent,
    ContextMenuComponent

  },
  data () {
      return {
        mainTable: "",
        name: "BomPartsAlternativeAggregatedTableComponent",
        id: "BomPartsAlternativeAggregatedTableComponent" + String(this._uid),
        columns: [],
        colsAssign: [],
        parts: [],
        isData: false,
        contextMenu: {},
        //list of items in the context menu
        menu: [
          {id: "Details", text: this.lang.contextmenu_text_Details},

        ],
      }
  },
  computed: {
    ...mapGetters({

      globalSettings: "globalSettings",
      partInBomToReload: "partInBomToReload"
    }),
    lastRevisionHistory() {
      if (this.$store.getters.revisionHistory == null) {
        return
      }
      let tab = this.$store.getters.revisionHistory;
      let obj = tab[0];
      for (let i = 0, lei = tab.length; i < lei; i++) {

        if (tab[i].revision > obj.revision) {
          obj = tab[i];
        }
      }

      return obj;
    },
    revisionId() {
      if (this.lastRevisionHistory == undefined) {
        return
      }
      return this.lastRevisionHistory.id;


    },
    projectId() {
      if (this.lastRevisionHistory == undefined) {
        return
      }
      return this.lastRevisionHistory.projectId;

    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }

    },
    reloadedAfterActionComplex() {
      return this.$store.getters.reloadedAfterActionComplex;
    },
    bomId() {
      return this.$route.query.bomId;
    }



  },
  created () {
    this.$store.dispatch(this.$store.getters.sectionPrefix + "_removeCheckboxVariant");
    this.createPartsTable();


  },
  watch: {
    tabIndex: function () {

      if (this.mainTable != ""){
        this.mainTable.rows().deselect();
      }
    },

    reloadedAfterActionComplex: {
      handler: function (newValue) {

        for (let el in newValue) {
          if (newValue[el].name == this.name) {
            if (newValue[el].status == true) {

              this.createPartsTable();

              newValue[el].status = false;

              this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
            }
          }
        }
      },
      deep: true

    },
    bomId: function () {

      this.$parent.$parent.$parent.$parent.$parent.$parent.setIsCore(this.isCore);

      this.createPartsTable();

    },

    partInBomToReload: {
      handler: function (newValue) {

        if (newValue.type == "setStatusMPN") {

          let partTagsPreferred = document.querySelectorAll(".bompart__" + newValue.distributorPartId + "_preferred");

          if (partTagsPreferred != null) {

            for (let i = 0, lei = partTagsPreferred.length; i < lei; i++){

              if (newValue.isPreferred == true) {
                partTagsPreferred[i].innerHTML = this.lang.alert_Preferred;
              } else {
                partTagsPreferred[i].innerHTML = "";
              }
            }
          }

          let partTagsNRND = document.querySelectorAll(".bompart__" + newValue.distributorPartId + "_nrnd");

          if (partTagsNRND != null) {

            for (let i = 0, lei = partTagsNRND.length; i < lei; i++){

              if (newValue.isNRND == true) {
                partTagsNRND[i].innerHTML = this.lang.alert_NRND;
              } else {
                partTagsNRND[i].innerHTML = "";
              }
            }
          }

          let partTagsForbidden = document.querySelectorAll(".bompart__" + newValue.distributorPartId + "_forbidden");

          if (partTagsForbidden != null) {

            for (let i = 0, lei = partTagsForbidden.length; i < lei; i++){

              if (newValue.isForbidden == true) {
                partTagsForbidden[i].innerHTML = this.lang.alert_Forbidden;
              } else {
                partTagsForbidden[i].innerHTML = "";
              }
            }
          }

        }
        if (newValue.type == "unassignPhysicals") {



          let mpn = document.querySelectorAll(".mpnpart_" + newValue.distributorPartId);

          if (mpn != null) {




              mpn.forEach(span => span.remove());

          }
        }






      },
      deep: true

    },
  },

  methods: {
    createPartsTable() {
      this.isData = false;
      let vue = this;

      const obj = {

        bomId: this.$route.query.bomId//this.$store.getters.selectedBomRow[0].bomId
      }


      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getBomWithPhysicalsAggregated", obj)
      .then((result) => {
        console.log(result)
        if (result.status == "OK"){

          if (result.data != undefined) {

            for (let i = 0, lei = result.data.parts.length; i < lei; i++){
              let trig = false;
              for (let j = 0, lej = result.data.parts[i].alternatives.length; j < lej; j++) {
                if (result.data.parts[i].alternatives[j].endOfPartAlert == true) {
                  trig = true;
                }

              }
              if (trig == true) {
                result.data.parts[i].endOfPartAlert = true;
              } else {
                result.data.parts[i].endOfPartAlert = false;
              }

            }

            this.parts = result.data.parts;

            vue.isData = true;
            vue.buildColumns();

            vue.isCore = result.data.isCore;

            vue.$parent.$parent.$parent.$parent.$parent.$parent.setIsCore(result.data.isCore);
          }

        }else{
            vue.isData = false;
        }


      })
    },
    buildColumns(){

      this.columns = [

        {
          name: this.lang.table_header_PartNumber,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Revision,
          alignInColumn: "left",
          type: "taxt"
        },
        {
          name: this.lang.table_header_PartReference,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Quantity,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Description,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Status,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_EOLalert,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_MPNs,
          alignInColumn: "left",
          type: "text"
        },
      ]

      this.colsAssign =  [

        { "data": "PartNumber" },
        { "data": "Revision" },
        { "data": "PartReference" },
        { "data": "Quantity" },
        { "data": "Description" },
        { "data": "revisionId" },
        { "data": "revisionId" },
        { "data": "bomPartId"},

      ]

      this.buildTable();
    },
    buildTable(){


      this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteSelectedPartBomRow");

      var tableplace = document.getElementById(this.id);
      if (tableplace == null) {
        return
      }
      while (tableplace.firstChild) {
          tableplace.removeChild(tableplace.firstChild);
      }

      var table = document.createElement("table");
      table.setAttribute("id", "place" + this._uid);
      table.setAttribute("style", "width:100%");
      table.setAttribute("class", "table table-striped table-bordered");
      tableplace.appendChild(table)

      var tr = document.createElement("tr");
      tr.setAttribute("class", "cellHeader");
      var thead = document.createElement("thead");
      thead.appendChild(tr);
      table.appendChild(thead);

      var _vue = this;


      let columnDefs = [];
      var len = this.columns.length;
      for (var i = 0; i < len; i++){

        var el = {};

        var classname = '_dt-body-' + this.columns[i].alignInColumn;

        if (i == 7) {
          classname = '_dt-body-' + this.columns[i].alignInColumn + ' no-wrap';
        }

        el = {
          targets: i,
          className: classname,

          render: function (data, type, row, meta) {
            if (data == null) {
              data = "";
            }

            data = $.fn.dataTable.render.text().display(data);
            if (data.display != undefined) {
              data.display = $.fn.dataTable.render.text().display(data.display);
            }
            if (meta.col == 0) {

              return "<span class=\"nowrapForPartNumber\">" + data + "</span>";
            }
            if (meta.col == 2) {
              return "<span class=\"part-reference\">" + data + "</span>";
            }
            if (meta.col == 5){
              if (data == undefined){
                  return ""
              }
              let str = "";
              // if (data == 0){
              //   str += "<b-badge class='badge badge-warning '>"+_vue.lang.tag_OutOfSync+"</b-badge>";
              // }else{
              //   str += "<b-badge class='badge badge-success '>"+_vue.lang.tag_Synchronized+"</b-badge>";
              // }
              if (row.status == "outOfSync") {
                str += "<b-badge class='badge badge-danger '>" + _vue.lang.tag_OutOfSync + "</b-badge>";
              } else if (row.status == "synchronized") {
                str += "<b-badge class='badge badge-success '>" + _vue.lang.tag_Synchronized + "</b-badge>";
              } else if (row.status == "oldRevision") {
                str += "<b-badge class='badge badge-warning '>" + _vue.lang.tag_OldRevision + "</b-badge>";
              }
              if (row.isManual == true) {
                str += " <b-badge class='badge badge-info '>" + _vue.lang.tag_IsManual + "</b-badge>";
              }
              if (row.isPresent == false) {
                str += " <b-badge class='badge badge-danger '>" + _vue.lang.tag_IsNotPresent + "</b-badge>";
              }
                return str;
            }
            if (meta.col == 6) {
              if (data == undefined) {
                return ""
              }
              let str = "";

              if (row.endOfPartAlert == true) {
                str += "<b-badge class='badge badge-danger '>" + "End of" + "</b-badge>";
              }
              return str;
            }

            if (meta.col == 7) {
              let str = '';


              if (_vue.globalSettings.SEDetails == false) {

                for (let i = 0, lei = row.alternatives.length; i < lei; i++){

                  let tags = "";

                  let preferred = "";
                  if (row.alternatives[i].isPreferred == true) {
                    preferred = _vue.lang.alert_Preferred;
                  }
                  tags += "<b-badge id=\"badge_" + row.alternatives[i].DistributorPartId + "_preferred\" class=\"badge badge-success " + "bompart__" + row.alternatives[i].DistributorPartId +"_preferred\">" + preferred + "</b-badge> ";

                  let nrnd = "";
                  if (row.alternatives[i].isNRND == true) {
                    nrnd = _vue.lang.alert_NRND;
                  }
                  tags += "<b-badge id=\"badge_" + row.alternatives[i].DistributorPartId + "_nrnd\" class=\"badge badge-purple " + "bompart__" + row.alternatives[i].DistributorPartId + "_nrnd\">" + nrnd + "</b-badge> ";

                  let forbidden = "";
                  if (row.alternatives[i].isForbidden == true) {
                    forbidden = _vue.lang.alert_Forbidden;
                  }
                  tags += "<b-badge id=\"badge_" + row.alternatives[i].DistributorPartId + "_forbidden\" class=\"badge badge-danger " + "bompart__" + row.alternatives[i].DistributorPartId +"_forbidden\">" + forbidden + "</b-badge> ";




                  if (row.alternatives[i].isSelected == true){
                    let count = i + 1;
                    let mpnrow = "mpn-row";

                    if (i == lei - 1) {
                      mpnrow = "";
                    }
                    str += "<span class=\""+mpnrow+" mpnpart_" + row.alternatives[i].DistributorPartId + "\">";
                    str += "<span class=\"inline-block\">";
                    str += count + ". " + row.alternatives[i].ManufacturerPartNumber + " | " + row.alternatives[i].ManufacturerName + " | " + row.alternatives[i].Description;
                    // if (tags != "") {
                    //   str += " | " + tags + "\r\n<br>";
                    // } else {
                    //   str += "\r\n<br>";
                    // }
                    if (tags != "") {
                      str += "&nbsp;|&nbsp;<span class=\"inline-block\">";
                      str += tags + "<br>\n\r";
                      str += "</span>";
                    } else {
                      str += "<br>\n\r";
                    }

                    str += "</span><br>";

                  }


                }

              } else {
                for (let i = 0, lei = row.alternatives.length; i < lei; i++){

                  let tags = "";

                  let preferred = "";
                  if (row.alternatives[i].isPreferred == true) {
                    preferred = _vue.lang.alert_Preferred;
                  }
                  tags += "<b-badge id=\"badge_" + row.alternatives[i].DistributorPartId + "_preferred\" class=\"badge badge-success " + "bompart__" + row.alternatives[i].DistributorPartId +"_preferred\">" + preferred + "</b-badge> ";

                  let nrnd = "";
                  if (row.alternatives[i].isNRND == true) {
                    nrnd = _vue.lang.alert_NRND;
                  }
                  tags += "<b-badge id=\"badge_" + row.alternatives[i].DistributorPartId + "_nrnd\" class=\"badge badge-purple " + "bompart__" + row.alternatives[i].DistributorPartId + "_nrnd\">" + nrnd + "</b-badge> ";

                  let forbidden = "";
                  if (row.alternatives[i].isForbidden == true) {
                    forbidden = _vue.lang.alert_Forbidden;
                  }
                  tags += "<b-badge id=\"badge_" + row.alternatives[i].DistributorPartId + "_forbidden\" class=\"badge badge-danger " + "bompart__" + row.alternatives[i].DistributorPartId +"_forbidden\">" + forbidden + "</b-badge> ";


                  let OverallRisk = "";
                  let valOverallRisk = "No data";
                  let statusOverallRisk = "primary";
                  if (row.alternatives[i].OverallRisk != undefined) {
                    OverallRisk = row.alternatives[i].OverallRisk.split("%");

                  }

                  let EstimatedYearsToEOL = "";
                  let valEstimatedYearsToEOL = "No data";
                  let statusEstimatedYearsToEOL = "primary";
                  if (row.alternatives[i].EstimatedYearsToEOL != undefined) {
                    EstimatedYearsToEOL = row.alternatives[i].EstimatedYearsToEOL;
                  }

                  if (OverallRisk != "") {
                    if (OverallRisk[0] <= _vue.globalSettings.SERiskRange1) {
                      valOverallRisk = "Low";
                      statusOverallRisk = "success";
                      if (OverallRisk == "") {
                        valOverallRisk = "No data";

                      }
                    }else if (OverallRisk[0] > _vue.globalSettings.SERiskRange2) {
                      valOverallRisk = "High";
                      statusOverallRisk = "danger";
                    } else if ((OverallRisk[0] > _vue.globalSettings.SERiskRange1) && (OverallRisk[0] <= _vue.globalSettings.SERiskRange2)) {
                      valOverallRisk = "Medium";
                      statusOverallRisk = "warning";
                    }
                  }


                  let value = parseFloat(EstimatedYearsToEOL);
                  let range1 = parseFloat(_vue.globalSettings.SEEOLRange1);
                  let range2 = parseFloat(_vue.globalSettings.SEEOLRange2);


                  if (EstimatedYearsToEOL != "") {
                    if (value <= range1) {

                      valEstimatedYearsToEOL = EstimatedYearsToEOL;
                      statusEstimatedYearsToEOL = "danger";

                    } else if (value > range2) {

                      valEstimatedYearsToEOL = EstimatedYearsToEOL;
                      statusEstimatedYearsToEOL = "success";
                    } else if ((value <= range2) && (value > range1)) {

                      valEstimatedYearsToEOL = EstimatedYearsToEOL;
                      statusEstimatedYearsToEOL = "warning";
                    }

                  }



                  if (row.alternatives[i].isSelected == true) {

                    let mpnrow = "mpn-row";

                    if (i == lei - 1) {
                      mpnrow = "";
                    }

                    str += "<span class=\""+mpnrow+" mpnpart_" + row.alternatives[i].DistributorPartId + "\">";
                    str += "<span class=\"inline-block\">";
                    let count = i + 1;
                    str += " " + count + ".";
                    str += "</span>";

                    str += "&nbsp;|&nbsp;<span class=\"se-risk inline-block\">";

                    if (OverallRisk[0] == 0 && row.alternatives[i].LifecycleRisk == "Unknown") {

                      str += "SE Risk: <b-badge class='badge badge-orange '>Incomplete</b-badge>" + "<br>";
                    } else {

                      str += "SE Risk: <b-badge class='badge badge-"+statusOverallRisk+" '>"+valOverallRisk+" </b-badge>" + "<br>";

                    }
                    str += "</span>";


                    str += "&nbsp;|&nbsp;<span class=\"se-eol inline-block\">";
                    str += "SE EOL: <b-badge class='badge badge-"+statusEstimatedYearsToEOL+" '>"+valEstimatedYearsToEOL+" </b-badge>" + "<br>";
                    str += "</span>";
                    str += "&nbsp;|&nbsp;<span class=\"inline-block\" style=\"min-width:150px\">";
                    str += row.alternatives[i].ManufacturerPartNumber + "<br>";
                    str += "</span>";
                    str += "&nbsp;|&nbsp;<span class=\"inline-block\" style=\"min-width:150px\">";
                    str += row.alternatives[i].ManufacturerName + "<br>";
                    str += "</span>";
                    str += "&nbsp;|&nbsp;<span class=\"inline-block\">";
                    str += row.alternatives[i].Description + "<br>";
                    str += "</span>";

                    if (tags != "") {
                      str += "&nbsp;|&nbsp;<span class=\"inline-block\">";
                      str += tags + "<br>\n\r";
                      str += "</span>";
                    } else {
                      str += "<br>\n\r";
                    }


                    str += "<br></span>";
                  }


                }
              }
              return str;



            }
            return data;
          }


        }

        columnDefs.push(el);


        var th = document.createElement("th");
        tr.appendChild(th);
        var br = document.createElement("br");
        th.appendChild(br);


        var tx = document.createTextNode(this.columns[i].name)
        th.appendChild(tx);

      }


      var option = {};
      option.paging = true;
      option.info = true;
      option.dom = '<fBl<t>ip>';
      option.data= this.parts;
      option.myColumnFormats = this.columns;
      option.select = true;
      option.order = [[0, "asc"]];
      option.lengthMenu = [[25, 50, -1], [25, 50, "All"]];
      option.columns = this.colsAssign;

      option.columnDefs = columnDefs;
      option.initComplete = function () {




      }
      option.fnDrawCallback = function( oSettings ) {

        //_vue.buildContextMenu();
      }
      option.buttons = [
        {
          extend: 'copy',
          className: 'btn-' + _vue.variant,
          exportOptions: {
              columns: ':visible'
          }
        },
        {
          extend: 'print',
          className: 'btn-' + _vue.variant,
          messageTop: function () {
            return _vue.lang.export_label_top + ": " + _vue.$store.getters.selectedProjectRow.name + ", " + _vue.lang.export_label_top2 + ": " + _vue.$store.getters.selectedProjectRow.revision;
          },
          exportOptions: {
            columns: ':visible'
          },
          autoPrint: true,
          style: 'fullWidth',

          customize: function ( win ) {
              $(win.document.body)
                  .css( 'font-size', '10pt' )


              $(win.document.body).find( 'table' )
                  .addClass( 'compact' )
                  .css( 'font-size', 'inherit' );
          }
        },
        {
          extend: 'csv',
          className: 'btn-' + _vue.variant,
          exportOptions: {
            columns: ':visible'
          },
        },
        {
          extend:'excel',
          exportOptions: {
            columns: ':visible'
          },
          className: 'btn-' + _vue.variant,
            customize: function ( xlsx ){

            var sheet = xlsx.xl.worksheets['PM_BOM.xml'];


        }},
        {
          extend: 'pdfHtml5',
          messageTop: function () {
                  return _vue.lang.export_label_top + ": " + _vue.$store.getters.selectedProjectRow.name + ", " + _vue.lang.export_label_top2 + ": " + _vue.$store.getters.selectedProjectRow.revision;
          },
          className: 'btn-' + _vue.variant,
          exportOptions: {
            columns: ':visible'
          },
          orientation: 'landscape',
          pageSize: 'A4',
          download: 'open',

          styles: {
            fullWidth: {
                fontSize: 3,
                bold: true,
                alignment: 'right',
                margin: [0,1900,0,80]
            },
            subheader: {
                fontSize: 4
            },
            superMargin: {
                margin: [20, 0, 40, 0],
                fontSize: 5,
            }
          },
          customize: function ( doc ) {


            doc.pageMargins = [10,10,10,10];

            doc.styles.title.fontSize = 9;
            doc.defaultStyle.fontSize = 7;
            doc.styles.tableHeader.fontSize = 9;
            doc.content[0].text = doc.content[0].text.trim();

            let numberOfHeaders = columnDefs.length;

            if ((numberOfHeaders > 10)&&(numberOfHeaders < 15)){

              doc.defaultStyle.fontSize = 5;
              doc.styles.tableHeader.fontSize = 7;
            }else if((numberOfHeaders >= 15)&&(numberOfHeaders < 18)){

              doc.defaultStyle.fontSize = 5;
              doc.styles.tableHeader.fontSize = 7;
            }else if(numberOfHeaders >= 18){

              doc.defaultStyle.fontSize = 3;
              doc.styles.tableHeader.fontSize = 5;
            }

          },

        },
        {
        text: 'Json',
        exportOptions: {
          columns: ':visible'
        },
        className: 'btn-' + _vue.variant,
            action: function ( e, dt, button, config ) {
                var data = dt.buttons.exportData();

                $.fn.dataTable.fileSave(
                    new Blob( [ JSON.stringify( data ) ] ),
                    'Parts.json'
                );
            }
        },
        {
          extend: 'colvis',
          className: 'btn-' + _vue.variant,

        },
      ];



      if ($.fn.dataTable.isDataTable("#place"+this._uid)) {
          this.mainTable.destroy();

      }

      var _vue = this;

      this.mainTable = $('#place'+this._uid).DataTable(option);

      this.mainTable.columns.adjust().draw();

      //hide first column in table
      //this.mainTable.column( 0 ).visible( false );

      let _mainTable = this.mainTable;

      this.mainTable
        .on( 'select', function ( e, dt, type, indexes ) {

          var rowData = _mainTable.rows( indexes ).data();

          //rowData[0].isPresent = true
          _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setSelectedPartBomRow", rowData[0])

        })
        .on( 'deselect', function ( e, dt, type, indexes ) {

          _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_deleteSelectedPartBomRow");
        })

        $('#place'+this._uid +" tbody").on('dblclick', 'tr', function () {


          let rowData = _mainTable.rows( this._DT_RowIndex ).data();

          _vue.goTo(rowData[0]);

        });

      //search input change view
      var searchplace = document.getElementById("place"+this._uid + "_filter").firstChild

      while (searchplace.firstChild) {

        if (searchplace.firstChild.textContent == "Search:"){
            searchplace.removeChild(searchplace.firstChild);
            break;
        }

      }
      searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
      searchplace.firstChild.setAttribute("class", "form-control form-control-sm")

      let lengthplace = document.getElementById("place"+this._uid+"_length").firstChild;
      lengthplace.firstChild.nextSibling.setAttribute("class", "form-control form-control-sm select-length");

    },
    buildContextMenu(){


      var _vue = this;

      //context-menu
      var tableid = $("#place" + this._uid);

      $("#place" + this._uid + " tbody tr")
      .on("contextmenu", function(e) {

        let tr = $(this).closest('tr');
        let row = _vue.mainTable.row( tr );

        let data = row.data();

        _vue.contextMenu.row = data


        _vue.contextMenu.funcAction = function(_vue, action){

          //calling component methods depending on the context menu item clicked




          return true;
        }


        var offsetX = tableid.offset().left;
        var offsetY = tableid.offset().top;

        var top = e.clientY - offsetY + 100;
        var left = e.clientX - offsetX + 10;



        $("#context-menu-"+_vue.id).css({
          display: "block",
          top: top,
          left: left,

        });

        return false; //blocks default Webbrowser right click menu
      })
      .on("click", function() {

        $("context-menu-"+_vue.id).hide();
      });

      $("#context-menu-"+_vue.id+" a").on("click", function() {

        $(this)
          .parent()
          .hide();
      });
      document.addEventListener('click', function(e){
        let clickInside = e.target.closest("#context-menu-"+_vue.id);


        if(clickInside == null){

          let contextMenu = document.getElementById("context-menu-"+_vue.id);
          if (contextMenu != null){

            contextMenu.setAttribute('style', 'display:none');
          }

        }
      });
      //context-menu
    },
    goTo(goalObj){


      if (goalObj.revisionId == 0){

        let obj = {
          text: this.lang.alert_OutOfSync,
          time: 15,
          type: "warning"
        }

        this.$store.dispatch("displayFooterAlert", obj);

        return
      }
      let from = "/ProjectManager/ProjectBom";

      let to = "/PartManager/PartDetails";
      let elementRevisionId = goalObj.revisionId;
      let id = goalObj.partId;
      let obj = {
        col___revisionId: {
          revisionId: goalObj.revisionId,
          partId: goalObj.partId
        },
        col___revision: {
          revisionId: goalObj.revisionId

        },
        col___status: {
          assembly: ""

        }
      }



      // const goToObj = {
      //   to: {
      //     path: to,
      //     revisionId: elementRevisionId,
      //     id: id
      //   },
      //   back: {
      //     path: from,
      //     revisionId: this.revisionId,
      //     id: this.projectId
      //   },
      //   bom: {
      //     selectedBomRow: this.$store.getters.selectedBomRow[0]
      //   }
      // }
      // this.$store.dispatch("goTo", goToObj);


      this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteSelectedBomRow");

      this.$store.dispatch("deleteAllSelectedRows");
      this.$store.dispatch("setSelectedRows", [obj]);

      this.$store.dispatch("setOuterData", true);

      this.$store.dispatch("editPropertiesForm", false);

      let sourceType = "main";
      if (this.$route.path == "/LibraryManager/LibraryDetails") {
        sourceType = "details";
      }
      if (this.$route.path == "/PartManager/PartDetails") {
        sourceType = "details";
      }
      if (this.$route.path == "/ProjectManager/ProjectBom") {
        sourceType = "details";
      }


      let routingObject = {
        from: this.$route.path,
        to: to,
        revisionId: elementRevisionId,
        id: id,
        sourceType: sourceType, //"details"
        sourceId: this.projectId,
        sourceRevisionId: this.revisionId,
        end: false,
        selectedBomRow: this.$store.getters.selectedBomRow[0],
        bomId: this.$route.query.bomId
      }

      this.$store.commit("FORWARDROUTINGDATA", routingObject)

      // const query = {
      //   from: this.$route.path,
      //   to: to,
      //   revisionId: elementRevisionId,
      //   id: id,
      //   sourceId: this.projectId,
      //   sourceRevisionId: this.revisionId,
      //   end: false
      // }


      this.$router.push({ path: to, query: routingObject });
    },

  }
}
</script>


<style lang="scss">
  @import "./../../scss/_custom.scss";
  .BomPartsAlternativeAggregatedTableComponent{
      width: 100%;
    .dataTable{
        width: 100%;
    }
    table{
      font-size: 0.75rem;
      padding: 0px !important;
      //width: 100%;
    }
    table th {
      padding: 2px !important;

    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;
      //white-space: nowrap;
    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }
    table.dataTable thead th p{
      margin-right: 20px;
    }

    .dataTables_processing {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .dataTables_length{
      margin-left: 20px;
      width: 200px;
      float: left;
    }
    .dataTables_length label{
      display: inline-flex;
    }
    .select-length{
      padding: 0.1rem;
      margin-left:10px;
      margin-right:10px;
    }
    .searcher{
      float: left;
    }
    .dt-buttons{

      font-size: 0.7rem;
      //margin-left: 210px;

    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    .btn{
      padding-top: 1px;
      padding-bottom: 1px;
      padding-left: 3px;
      padding-right: 3px;

      font-size: 0.7rem;

    }
    .btn-group{
      display: block;
      padding-top: 2px;
      width: 320px;
      float: left;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .image{
      max-width: 40px;
      border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
    }
    .imageSVG{
      max-width: 40px;
      border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
      padding: 5px;
    }
    .badge {
      margin: 2px;
    }
    .nowrapForPartNumber{
      white-space: nowrap;
    }
    .subtable .selected{
      color: red;

    }
    tr .selected {
      color: red;

    }
    .se-risk{
      width: 110px;
    }
    .se-eol{
      width: 110px;
    }
    .no-wrap{
      white-space: nowrap;
    }
    .part-reference{
      width: 200px;
      //white-space: nowrap;
      display:block;
    }
    .se-risk{
      width: 110px;
    }
    .se-eol{
      width: 110px;
    }
    .inline-block {
      display: inline-block;
      margin-right: 5px; /* Przykładowy odstęp między elementami */
    }
    .mpn-row{
      border-bottom: 1px solid;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/BomPartsAlternativeAggregatedTableComponent.vue